/**
 * How a dry run's email block reads (Ben, 24 Oct): the one line it is shown
 * collapsed under, and the line counting the further emails a command sends.
 * The email itself is the backend's, composed by the code that sends it.
 */
import type { EmailBlock } from "./contract";

/** "orders@printcraft.example", "a@x.example and b@y.example", "a@x.example, b@y.example and c@z.example". */
export function addressList(addresses: readonly string[]): string {
  if (addresses.length <= 1) return addresses[0] ?? "";
  return `${addresses.slice(0, -1).join(", ")} and ${addresses[addresses.length - 1]}`;
}

/** The collapsed line: "The email to orders@printcraft.example". */
export function emailHeading(block: EmailBlock): string {
  return `The email to ${addressList(block.to)}`;
}

/** "…and 2 more like it, one to each supplier", or null when the command sends only this email. */
export function moreLikeIt(block: EmailBlock): string | null {
  if (!block.count_more) return null;
  const label = block.count_more_label ? `, ${block.count_more_label}` : "";
  return `…and ${block.count_more} more like it${label}`;
}
